// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_2x2HD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/PageContentWrapper/PageContentWrapper.scss
// module id = ./src/components/Page/PageContentWrapper/PageContentWrapper.scss
// module chunks = 4